module.exports = __webpack_public_path__ + "media/src/images/balloons/iversity-banner-kursseite-black-sale-en-f89f794a5127964e34b634bfbad66974.jpg";